module.exports = __webpack_public_path__ + "img/styria-media-group-logo-v3.be780630.svg";